var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5035",
    "data-name": "Group 5035",
    xmlns: "http://www.w3.org/2000/svg",
    width: 307.501,
    height: 406.358,
    viewBox: "0 0 307.501 406.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_120",
    "data-name": "Ellipse 120",
    cx: 82.957,
    cy: 82.957,
    r: 82.957,
    transform: "translate(71.276)",
    fill: "#314155"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2931",
    "data-name": "Path 2931",
    d: "M153.75,0A153.751,153.751,0,0,1,307.5,153.75c0,84.914-307.5,84.914-307.5,0A153.751,153.751,0,0,1,153.75,0Z",
    transform: "translate(0 188.922)",
    fill: "#314155"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ad999488.svg";
export { ForwardRef as ReactComponent };